import Swiper, {Autoplay, Navigation} from "swiper";
import {fromEvent} from "rxjs";
import {map, startWith, tap} from "rxjs/operators";


export const initImageCarouselSwiper = (swiperSelector) => {
    Swiper.use([Autoplay, Navigation]);
    if(jQuery(swiperSelector).length == 0){
        return;
    }
    let swiper;
    swiper = new Swiper(swiperSelector, {
        autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        loop: true,
        speed: 800,
        //effect: 'fade',
        navigation: {
           nextEl: ".swiper-next",
           prevEl: ".swiper-prev"
        },
        // spaceBetween: 40,
        allowSlidePrev: true,
        allowTouchMove: true
    });

}
